import {History} from '../../../graphql-typings/graphql';
import {FunctionName} from './chart-function-types';
import {AbstractFunction} from './abstract-function';

export class DifferenceFunction extends AbstractFunction {

  readonly overflow = 1;

  constructor() {
    super(FunctionName.DIF, 'Difference');
  }

  run(historyArray: History[]): History[] {
    const result: History[] = [];
    if (historyArray && historyArray.length) {
      for (let i = 0; i < historyArray.length - 1; i++) {
        const h = historyArray[i + 1];
        result.push(Object.assign({}, h, {data: h.data - historyArray[i].data}));
      }
    }
    return result;
  }
}
